<template>
  <div class="page">
    <!-- 背景图 -->
    <div class="swiper">
      <swiper :options="swiperOptions">
        <swiper-slide v-for="(url, index) in dataList" :key="`url-${index}`">
          <img :src="url" />
        </swiper-slide>
      </swiper>
    </div>

    <!-- 智慧工厂 -->
    <div class="smartFactory fade-in-section">
      <p class="content-title">智慧工厂</p>
      <div class="content-text">-- 聚焦视觉检测，赋能工业自动化智能产线 --</div>
      <div class="product-list">
        <div class="product-item" v-for="(item, index) in smartFactoryList" :key="index">
          <div class="product-icon-box">
            <img loading="lazy" :src="item.imgUrl" :alt="item.title + '图标'" class="product-icon" />
          </div>
          <h3 class="product-title">{{ item.title }}</h3>
          <div class="product-desc">
            <p class="describe-text" v-for="(d, dindex) in item.desc" :key="dindex">
              <i class="el-icon-success" style="color: #67c23a"></i>
              {{ d }}
            </p>
          </div>
          <el-button type="primary" @click="handleSmartDetail(item.name)" class="detail-btn">
            查看详情
            <i class="el-icon-right"></i>
          </el-button>
        </div>
      </div>
    </div>

    <!-- 机器人 -->
    <div class="robot fade-in-section">
      <p class="content-title">机器人</p>
      <div class="content-text">
        -- 赋能工业场景，打造高精准智能机器人解决方案 --
      </div>
      <div class="robot-list">
        <div class="robot-item" v-for="(item, index) in robotList" :key="index" :class="{ 'row-two': index === 4 }"
          @click="handleRobotDetail(item.type)">
          <div class="robot-content">
            <p class="robot-type">{{ item.type }}</p>
            <h4 class="robot-title">{{ item.title }}</h4>
            <p class="robot-detail">查看详情</p>
          </div>
          <img loading="lazy" :src="item.bgImg" :alt="item.title" />
          <div class="robot-mask"></div>
        </div>
      </div>
    </div>

    <!-- AI数字人 -->
    <!-- <div class="digital fade-in-section">
      <div class="content-title">AI数字人</div>
      <div class="content-text">-- 开启智能交互新视界，灵动呈现无限可能 --</div>
      <div class="contro">
        <div class="content">
          <p class="contro-text">
            &#12288;&#12288;深圳云码通科技有限公司，聚焦 AI
            数字人技术研发，构建起 “自主移动” 与 “陪伴服务”
            两大核心产品体系，精准覆盖不同场景需求：
          </p>
          <p class="contro-text">
            &#12288;&#12288;自主移动 AI
            数字人具备多场景自主移动能力与高度拟人化交互表现，以流畅的肢体动作配合情感化语音对话，广泛适用于智能导览、公共服务、商业接待等领域，重新定义
            “人机共融” 的场景化服务新体验。
          </p>
          <p class="contro-text">
            &#12288;&#12288;陪伴类 AI
            数字人则以轻量化、场景化定位满足多元陪伴需求：其中
            全息仓AI数字人兼顾低成本与全功能，凭借灵动可爱的形象与精准语义理解，适配家庭陪伴、教育互动、企业助手等场景；龙小伴AI数字人
            身形小巧便携，作为 24 小时在线的智能伙伴，搭载
            AI大模型并支持云端更新迭代，实现功能持续进化，为用户提供随身、智能的陪伴与服务支持。
          </p>
          <p class="contro-text">
            &#12288;&#12288;两大品类协同发力，从场景化服务到个性化陪伴，为个人与企业用户提供全方位、灵活化的
            AI 数字人解决方案。
          </p>
        </div>
        <div class="area">
          <div
            v-for="(item, index) in areas"
            :key="`area-${index}'`"
            class="circle"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <ul class="clearfix">
        <li
          @click="gotoDigitalPage(item.url)"
          v-for="(item, index) in digitalList"
          :key="`product-${index}`"
        >
          <div class="fadeInUp">
            <img loading="lazy" :src="item.imgUrl" alt />
            <h3>{{ item.name }}</h3>
            <p>{{ item.text }}</p>
            <div class="detail" style="color: #0093dc">
              点击了解详情
              <span class="text-2xl font-bold text-blue-600 arrow-shake"
                >>></span
              >
            </div>
          </div>
        </li>
      </ul>
    </div> -->

  </div>
</template>

<script type="text/ecmascript-6">

export default {
  name: "page",
  data() {
    return {
      dataList: [
        require('@/assets/Home/Home_main.jpg'),
        require('@/assets/Home/Home_slogan.jpg'),
        // require('@/assets/Home/AI.jpg'),
      ],
      // 轮播图配置自动播放
      swiperOptions: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, // 用户操作后继续自动播放
          stopOnLastSlide: false // 循环播放
        },
      },
      areas: [
        "人工智能",
        "云计算",
        "华为技术认证书",
        "CRCA安全测评证书",
        "人机技术",
        "40余项专利和软件著作权",
      ],
      digitalList: [
        {
          url: 'Mobile',
          imgUrl: require('@/assets/Home/mobile.png'),
          name: '自主移动AI数字人',
          text: '会走、会说、会思考，让 “人机对话” 变成真实的 “伙伴交流”'
        },
        {
          url: 'Holography',
          imgUrl: require('@/assets/Home/holography.png'),
          name: '全息仓AI数字人',
          text: '以灵动形象和精准理解，把贴心陪伴与智能助手装进口袋之外的 “小空间”'
        },
        {
          url: 'Phone',
          imgUrl: require('@/assets/Home/phone.png'),
          name: '龙小伴AI数字人',
          text: '一款只有巴掌大小的智能终端，却拥有无限的情感能量与智慧交互能力'
        }
      ],
      smartFactoryList: [
        {
          imgUrl: require('@/assets/smartFactory/icon/i1.png'),
          name: 'Carton',
          title: '纸箱缺陷检测设备',
          desc: [
            '物料漏放、放反、放错检测',
            '自动摆正纸箱，无需人工干预',
            '可视化预警，NG记录自动存储',
            '智能读码，匹配对应检测模型',
          ]
        },
        {
          imgUrl: require('@/assets/smartFactory/icon/i2.png'),
          name: 'Cable',
          title: '线缆表面缺陷检测',
          desc: [
            '脱料、划伤、凸起等多缺陷检测',
            'AI自动学习优化，抗环境干扰',
            '视听双重提示，避免错检漏检',
            '月度检测记录，方便复盘统计',
          ]
        },
        {
          imgUrl: require('@/assets/smartFactory/icon/i3.png'),
          name: 'DieCutting',
          title: '模切套准识别平台',
          desc: [
            '0.1秒极速识别，不良品率降为0',
            '支持7*24小时不间断工作',
            '超10万条OK/NG记录存储查询',
            '0.04毫米/像素超高精度检测',
          ]
        },
        {
          imgUrl: require('@/assets/smartFactory/icon/i4.png'),
          name: 'OpticalFiber',
          title: '光纤线序检测仪',
          desc: [
            '光学显微成像，高倍率工业相机',
            '线序颜色顺序错位智能检测',
            '降低人工判别疲劳，提升准确率',
            '声音文字提醒，快速识别错误',
          ]
        },
        {
          imgUrl: require('@/assets/smartFactory/icon/i5.png'),
          name: 'WashHands',
          title: '洗手流程检测',
          desc: [
            '深度学习结合目标检测与追踪',
            '精准识别执行情况及时长',
            '违规时自动语音播报，及时提醒纠正',
            '数据收集，助力评估改进',
          ]
        },
        {
          imgUrl: require('@/assets/smartFactory/icon/i6.png'),
          name: 'CigaretteButt',
          title: '智能烟头检测系统',
          desc: [
            '复杂环境下精准识别烟头',
            '7x24小时不间断实时监控',
            ' PC端远程管理，查看历史记录',
            '可扩展警示灯、喇叭报警',
          ]
        },
      ],
      robotList: [
        {
          type: 'LM-1',
          title: '龙马一号激光导航室外巡检机器人',
          bgImg: require('@/assets/robot/LM1/p1.png'),
        },
        {
          type: 'LM-2',
          title: '龙马二号远程驾驶室外巡逻机器人',
          bgImg: require('@/assets/robot/LM2/p1.png'),
        }, {
          type: 'LM-4',
          title: '龙马四号室内巡检机器人',
          bgImg: require('@/assets/robot/LM4/p1.jpg'),
        }, {
          type: 'LM-D1',
          title: '吊轨巡检机器人',
          bgImg: require('@/assets/robot/LMD1/p1.png'),
        }, {
          type: 'LM-G1',
          title: '光伏板清扫机器人',
          bgImg: require('@/assets/robot/LMG1/p1.png'),
        }

      ],
    }
  },
  mounted() {
    // 创建观察者实例
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // 只触发一次
        }
      });
    }, {
      threshold: 0.1 // 元素进入视口10%时触发
    });

    // 监听所有需要渐入的元素
    document.querySelectorAll('.fade-in-section').forEach(section => {
      observer.observe(section);
    });
  },
  methods: {
    gotoDigitalPage(url) {
      this.$router.push({
        name: url
      }).then(() => {
        window.scrollTo(0, 0); // 跳转后滚动到顶部
      });
    },
    handleSmartDetail(model) {
      this.$router.push({
        name: 'SmartFactory',
        query: { model }
      }).then(() => {
        window.scrollTo(0, 0); // 跳转后滚动到顶部
      });;
    },
    handleRobotDetail(model) {
      this.$router.push({
        name: 'Robot',
        query: { model }
      });
    }
  },
}
</script>

<style scoped lang="scss">
// 了解详情箭头摇晃动画
@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(5px);
  }

  75% {
    transform: translateX(-5px);
  }
}

.page {
  text-align: center;

  .swiper {
    margin: 0 auto;

    img {
      width: 100%;
      max-height: 75rem;
    }
  }

  .content-text {
    font-size: 2rem;
    color: #848793;
    text-align: center;
    padding: 1rem 0 3rem 0;
  }
}

// 数字人展示
.digital {
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .contro {
    width: 1200px;
    height: 500px;
    display: flex;

    .content {
      width: 50%;
      text-align: left;
      padding: 2rem 0;
      margin-top: 1.5rem;

      .contro-text {
        font-size: 1.8rem;
        color: #00000098;
      }
    }

    .area {
      position: relative;
      width: 550px;
      margin-left: 20px;

      .circle {
        position: absolute;
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background-color: rgba(59, 130, 246, 0.7);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        padding: 10px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
        z-index: 1;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        &:nth-child(1) {
          transform: translate(-50%, -50%) rotate(0deg) translate(130px) rotate(0deg);
        }

        &:nth-child(2) {
          transform: translate(-50%, -50%) rotate(60deg) translate(130px) rotate(-60deg);
        }

        &:nth-child(3) {
          transform: translate(-50%, -50%) rotate(120deg) translate(130px) rotate(-120deg);
        }

        &:nth-child(4) {
          transform: translate(-50%, -50%) rotate(180deg) translate(130px) rotate(-180deg);
        }

        &:nth-child(5) {
          transform: translate(-50%, -50%) rotate(240deg) translate(130px) rotate(-240deg);
        }

        &:nth-child(6) {
          transform: translate(-50%, -50%) rotate(300deg) translate(130px) rotate(-300deg);
        }

        /* 鼠标悬停效果 */
        &:hover {
          transform: translate(-50%, -50%) rotate(var(--rotation)) translate(150px) rotate(calc(-1 * var(--rotation))) scale(1.1);
          z-index: 10;
          background-color: rgb(59, 130, 246);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        }

        /* 为每个圆设置旋转变量，用于hover效果 */
        &:nth-child(1) {
          --rotation: 0deg;
        }

        &:nth-child(2) {
          --rotation: 60deg;
        }

        &:nth-child(3) {
          --rotation: 120deg;
        }

        &:nth-child(4) {
          --rotation: 180deg;
        }

        &:nth-child(5) {
          --rotation: 240deg;
        }

        &:nth-child(6) {
          --rotation: 300deg;
        }
      }
    }
  }

  ul {
    width: 1200px;
    margin: 1rem auto;
    min-height: 350px;

    li {
      float: left;
      width: 360px;
      height: 480px;
      margin-right: 60px;
      cursor: pointer;

      .fadeInUp {
        width: 100%;
        height: 100%;
        background-color: #fff;
        box-sizing: border-box;
        padding: 45px;
        border: 0.013333rem solid #e9edf7;
        text-align: center;

        img {
          display: inline-block;
          width: auto;
          height: 250px;
        }

        h3 {
          color: #34363d;
          margin-top: 28px;
          margin-bottom: 10px;
          font-weight: 500;
          font-size: 18px;
        }

        p {
          color: #848793;
          font-size: 1.6rem;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
        }

        .detail {
          font-size: 1.6rem;
          text-align: right;

          .arrow-shake {
            display: inline-block; // 必须加！否则transform无效
            font-size: 1.8rem;
            margin-left: 2px;
            animation: shake 1.5s ease-in-out infinite; // 关联动画
          }
        }
      }

      &:hover {
        box-shadow: 0 10px 20px rgba(42, 123, 220, 0.3);
        transform: translateY(-5px);
        border-color: #0093dc;
        background-color: #f9fcff;

        img {
          transform: scale(1.2);
        }
      }
    }

    li:last-child {
      margin-right: 0;
    }
  }
}

// 智慧工厂展示
.smartFactory {
  padding: 1rem 0;

  .product-list {
    margin: 0 auto;
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    gap: 3rem;
    justify-content: center;
  }

  .product-item {
    width: calc((100% - 6rem) / 3);
    background-color: #fff;
    border-radius: 1.2rem;
    padding: 3rem 2.5rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2.5rem;
    text-align: center;
    overflow: hidden;

    // 卡片hover效果
    &:hover {
      transform: translateY(-1rem);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

      .product-icon-box {
        background-color: var(--primary-color);
        transform: scale(1.1);
        box-shadow: 0 0 20px rgba(64, 158, 255, 0.3);
      }

      .product-icon {
        filter: brightness(0) invert(1);
      }
    }
  }

  // 小图标容器
  .product-icon-box {
    width: 10rem;
    height: 10rem;
    border-radius: 50%;
    background-color: #e8f4ff;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;

    .product-icon {
      width: 6rem;
      height: 6rem;
      object-fit: contain;
      transition: all 0.3s ease;
    }
  }

  .product-title {
    font-size: 2.2rem;
    font-weight: 600;
    color: #1d2129;
    margin: 0;
    padding-bottom: 1rem;
    border-bottom: 1px solid #f2f3f5;
    width: 100%;
  }

  .product-desc {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    flex: 1;
    width: 100%;
  }

  .describe-text {
    font-size: 1.8rem;
    color: #4e5969;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 1rem;
    line-height: 1.6;
    padding-left: 1rem;
  }

  .detail-btn {
    width: 100%;
    height: 5rem;
    font-size: 1.8rem;
    border-radius: 0.8rem;
    background-color: var(--primary-color);
    border-color: var(--primary-color);
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: auto;

    &:hover {
      background-color: #2585e6;
      border-color: #2585e6;
      transform: scale(1.02);
    }

    &:active {
      transform: scale(0.98);
    }
  }
}

// 机器人
.robot {
  padding: 2rem 0;

  .robot-list {
    width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto auto;
    gap: 1.5rem;

    .robot-item {
      position: relative;
      height: 400px;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease;

      // 图片样式
      img {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      // 蒙版样式
      .robot-mask {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: linear-gradient(to top,
            rgba(0, 0, 0, 0.5),
            rgba(0, 0, 0, 0.1));
        transition: background 0.3s ease;
      }

      // 内容容器
      .robot-content {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 2;
        width: 100%;
        padding: 2rem;
        text-align: left;
        color: white;
        transition: bottom 0.3s ease;
      }

      // 文字样式
      .robot-type {
        font-size: 1.8rem;
        margin: 0 0 0.5rem 0;
        opacity: 0.9;
      }

      .robot-title {
        font-size: 2.2rem;
        font-weight: 700;
        margin: 0 0 1rem 0;
        line-height: 1.3;
      }

      .robot-detail {
        font-size: 1.6rem;
        display: flex;
        align-items: center;
        gap: 0.8rem;
        opacity: 0;
        transform: translateY(10px);
        transition: all 0.3s ease;
        margin: 0;

        &::after {
          content: "→";
          font-size: 1.8rem;
          transition: transform 0.3s ease;
        }
      }

      // hover效果
      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);

        img {
          transform: scale(1.05);
        }

        .robot-mask {
          background: linear-gradient(to top,
              rgba(0, 0, 0, 0.6),
              rgba(0, 0, 0, 0.2));
        }

        .robot-content {
          bottom: 1rem;
        }

        .robot-detail {
          opacity: 1;
          transform: translateY(0);
        }

        .robot-detail::after {
          transform: translateX(5px);
        }
      }
    }

    .row-two {
      grid-column: span 2;
    }
  }
}

// 响应式设计
@media screen and (max-width: 768px) {
  .content-text {
    font-size: 1.2rem !important;
    padding: 0 !important;
  }

  // 数字人区域
  .digital {
    padding: 10px 0;

    .contro {
      width: 100% !important;
      height: auto !important;
      flex-direction: column !important;
      padding: 0 1rem;

      .content {
        width: 100% !important;
        padding: 1rem 0 !important;
        margin-top: 0 !important;

        .contro-text {
          font-size: 1.2rem !important;
          line-height: 1.6 !important;
          margin-bottom: 0.8rem;
        }
      }

      .area {
        display: none;
      }
    }

    // 产品列表
    ul {
      width: 100% !important;
      padding: 0 1rem;
      min-height: auto !important;

      li {
        float: none !important;
        width: 100% !important;
        height: auto !important;
        margin-right: 0 !important;
        margin-bottom: 2rem;
        margin: 0.3rem;
        cursor: pointer;

        .fadeInUp {
          padding: 10px !important;
          height: 125px !important;

          img {
            width: auto !important;
            height: 100px !important;
            float: left;
            margin-right: 20px;
          }

          h3 {
            font-size: 16px !important;
            text-align: left;
            margin-top: 15px !important;
          }

          p {
            font-size: 1.2rem !important;
            line-height: 1.5 !important;
          }

          .detail {
            font-size: 1rem !important;
            margin-top: 1rem;

            .arrow-shake {
              font-size: 1rem !important;
            }
          }
        }

        &:hover {
          transform: translateY(0) !important;

          img {
            transform: scale(1) !important;
          }
        }
      }
    }
  }

  // 机器人
  .robot {
    padding: 1rem;

    .robot-list {
      width: 100%;
      grid-template-columns: repeat(2, 1fr); // 2列布局
      padding: 0 0.5rem;
      gap: 0.8rem;
      margin-top: 1.5rem;

      .robot-item {
        height: 260px; // 大幅缩小卡片高度
        border-radius: 8px;

        .robot-content {
          padding: 1rem;
        }

        .robot-type {
          font-size: 1.4rem;
        }

        .robot-title {
          font-size: 1.6rem;
          margin-bottom: 0.5rem;
        }

        .robot-detail {
          font-size: 1.3rem;
        }

        // 取消跨列样式，保持2列统一
        &.row-two {
          grid-column: span 1;
        }
      }
    }
  }

  // 智慧工厂
  .smartFactory {
    padding: 1rem;

    .product-list {
      width: 100%;
      gap: 1.2rem;
      padding: 0 0.5rem;
      margin-top: 1.5rem;
    }

    .product-item {
      width: calc((100% - 1.2rem) / 2);
      padding: 1.5rem 1rem;
      gap: 1.2rem;

      // 进一步缩小图标容器和图标
      .product-icon-box {
        width: 6rem;
        height: 6rem;

        .product-icon {
          width: 3.5rem;
          height: 3.5rem;
        }
      }

      .product-title {
        font-size: 1.6rem;
        padding-bottom: 0.8rem;
      }

      .describe-text {
        font-size: 1.3rem;
        gap: 0.8rem;
        display: none;
      }

      // 进一步缩小按钮尺寸
      .detail-btn {
        height: 3.8rem;
        font-size: 1.4rem;
        padding: 0 0.8rem;

        i {
          font-size: 1.2rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue